import { observer } from 'mobx-react-lite'
import { useFeatures } from '@/contexts/root-store-context'
import { Outlet, useOutletContext } from 'react-router'
import { type ProfileOutletContext } from '@/features/iam/users/Profile/ProfileContainer'
import { ProfileHeaderContainer } from '@/features/iam/users/components/ProfileHeader/ProfileHeaderContainer'
import { useActivation } from '@/hooks/view-model-hooks'
import { useDocumentTitle } from '@/hooks/document-title'
import { StripeConnectPayoutModal } from '@/features/billing/components/StripeConnectPayoutModal'
import { Billing, BillingTabBar } from '@/features/iam/users/Profile/Billing'

export default observer(function BillingContainer() {
  const { vm, scrollOffset } = useOutletContext<ProfileOutletContext>()
  const { shellInfo } = useFeatures(({ shell }) => ({
    shellInfo: shell.shellInfo,
  }))
  const billing = vm.billing
  useActivation(billing)
  useDocumentTitle('Billing')

  return (
    <Billing
      header={
        <ProfileHeaderContainer
          viewTitle="Billing"
          vm={vm}
          scrollOffset={scrollOffset}
          tabBar={<BillingTabBar isPayoutsEnabled={billing.isPayoutsEnabled} />}
        />
      }
      stripeConnectPayoutModal={
        <StripeConnectPayoutModal
          corporateMode={shellInfo.corporateMode}
          showing={billing.stripeConnectModalVm.modal.showing}
          state={billing.stripeConnectModalVm.connect.match({
            pending: () => 'pending',
            rejected: () => 'error',
            resolved: () => 'done',
          })}
          onCloseRequest={billing.stripeConnectModalVm.modal.close}
          error={
            billing.stripeConnectModalVm.connect.rejected
              ? billing.stripeConnectModalVm.connect.error
              : null
          }
        />
      }
    >
      <Outlet context={billing} />
    </Billing>
  )
})
